import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  prereqs: [
    'Tener los Sistemas y Componentes cargados para poder asignarlos.',
  ],
  tips: [
    'Las tareas describen la acción: "Cambio de aceite de motor", "Inspección de frenos".',
    'Asociá cada tarea al componente que se interviene para poder cargar repuestos recomendados en los planes de mantenimiento.',
    'Usá verbos claros: Cambiar, Inspeccionar, Limpiar, Ajustar, Lubricar.',
  ],
  nextSteps: [
    'Crear Rutinas para agrupar las tareas por frecuencias.',
    'Armar los Planes de mantenimiento e incluir estas tareas en las rutinas.',
    'Utilizar las tareas creadas para registrar trabajos realizados en las reparaciones correctivas.',
  ],
};

const ConfiguracionTareas = () => (
  <ConfiguracionBase
    apiEndpoint="tareas"
    titulo="Tareas"
    descripcion="Tareas de mantenimiento"
    icon="fas fa-tasks"
    compact
    help={HELP}
  />
);

export default ConfiguracionTareas;
